import axios from "axios";

// This function will be called only when a user clicks to view a document
export const getDocumentUrl = async (documentId) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_LAWS_BACKEND_HOST}/docs/v1/documents/longPdfUrl`,
      null,
      {
        params: {
          documentId,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(`Error fetching document URL for ID ${documentId}:`, error);
    throw error;
  }
}; 